export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-bold text-accent-400 whitespace-nowrap">成全影视</span>
            <p className="text-sm text-foreground-300 mt-3 leading-relaxed">
              你的高清免费影视平台。海量影视资源，每日更新，免VIP免注册，随时随地畅享追剧乐趣。
            </p>
            <div className="flex items-center gap-2 mt-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 cursor-pointer transition-colors duration-200">
                <i className="ri-wechat-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 cursor-pointer transition-colors duration-200">
                <i className="ri-weibo-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 cursor-pointer transition-colors duration-200">
                <i className="ri-bilibili-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 cursor-pointer transition-colors duration-200">
                <i className="ri-vidicon-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '影视精选', href: '#media' },
                { label: '焦点专题', href: '#carousel' },
                { label: '精彩推荐', href: '#cards' },
                { label: '热度榜单', href: '#ranking' },
                { label: '全站索引', href: '#index' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-sm text-foreground-300 hover:text-accent-400 cursor-pointer transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {['热门电影', '热播剧集', '人气动漫', '综艺娱乐', '纪录片'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-sm text-foreground-300 hover:text-accent-400 cursor-pointer transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              诚挚感谢所有合作伙伴的支持与信任。我们期待与更多优秀的内容方、平台方携手，共同为用户带来更丰富的观影体验。
            </p>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-1 mt-3 text-sm text-accent-400 hover:text-accent-300 cursor-pointer transition-colors duration-200 whitespace-nowrap"
            >
              成为合作伙伴 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2024 成全影视 chengquan.video · 高清免费影视平台 · 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 cursor-pointer whitespace-nowrap transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 cursor-pointer whitespace-nowrap transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 cursor-pointer whitespace-nowrap transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}